function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function safeHref(href: string): string | null {
  const trimmed = href.trim()
  if (/^https?:\/\//i.test(trimmed) || /^mailto:/i.test(trimmed)) return trimmed
  return null
}

/** Bold, code, and links. The rest stays as text so a proposed edit matches the note. */
export function inlineToHtml(text: string): string {
  const pattern = /\*\*([^*]+)\*\*|`([^`]+)`|\[([^\]\n]+)\]\(([^)\s]+)\)/g
  let html = ''
  let last = 0
  for (const match of text.matchAll(pattern)) {
    const index = match.index ?? 0
    html += escapeHtml(text.slice(last, index))
    if (match[1] != null) html += `<strong>${inlineToHtml(match[1])}</strong>`
    else if (match[2] != null) html += `<code>${escapeHtml(match[2])}</code>`
    else {
      const href = safeHref(match[4] ?? '')
      const label = inlineToHtml(match[3] ?? '')
      html += href ? `<a href="${escapeHtml(href)}">${label}</a>` : label
    }
    last = index + match[0].length
  }
  html += escapeHtml(text.slice(last))
  return html
}

/** Read rich text back to markdown after an edit in the review. */
export function inlineMarkdownFrom(node: Node): string {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent ?? ''
  if (!(node instanceof HTMLElement)) return ''
  if (node.tagName === 'BR') return '\n'
  const inner = Array.from(node.childNodes).map(inlineMarkdownFrom).join('')
  if (node.tagName === 'STRONG' || node.tagName === 'B') return `**${inner}**`
  if (node.tagName === 'CODE') return `\`${inner}\``
  if (node.tagName === 'A') {
    const href = node.getAttribute('href') ?? ''
    return href ? `[${inner}](${href})` : inner
  }
  return inner
}
